/**
 * Generic column helpers for {@link ../components/datatable/AdminDataTable.jsx} and domain configs.
 * Column defs: `{ key, label, aliases?: string[], html?: boolean, defaultVisible?: boolean }`.
 */

export function pickRowValue(row, def) {
  if (!row || !def) return null;
  if (row[def.key] != null && row[def.key] !== "") return row[def.key];
  for (const a of def.aliases || []) {
    if (row[a] != null && row[a] !== "") return row[a];
  }
  return null;
}

/** Strip HTML for client-side search helpers */
export function rowSearchText(row, defs) {
  if (!row) return "";
  const parts = [];
  for (const d of defs) {
    const v = pickRowValue(row, d);
    if (v == null) continue;
    const s = String(v).replace(/<[^>]+>/g, " ");
    parts.push(s);
  }
  return parts.join(" ").toLowerCase();
}
